import { FormattedMessage } from 'react-intl';
import FormattedDuration, { TIMER_FORMAT } from 'react-intl-formatted-duration';

import { Button } from '../../../../../../../common/button-new';
import { SubmitButtonProps } from './submit-button.models';
import { RecaptchaActions } from '../../../../../../../../rest/consumer';
import { CaptchaType } from '../../../../../../../../graphql/configuration';

export const SubmitButton = ({
  isValueValid,
  requestCodeTime,
  onRequestCode,
  isDisabled,
  captchaType,
}: SubmitButtonProps): JSX.Element => {
  const ButtonNoSubmit = () => (
    <>
      {isDisabled ? (
        <Button
          type="button"
          style="dark"
          testId="request-another-code-timer-button"
          disabled={isDisabled}
          onClick={onRequestCode}
        >
          <FormattedMessage
            id="registration.confirmationCodeStep.requestNewCodeInButton.label"
            values={{
              timeLeft: <FormattedDuration seconds={requestCodeTime} format={TIMER_FORMAT} />,
            }}
          />
        </Button>
      ) : (
        <Button
          type="button"
          style="dark"
          testId="request-another-code-button"
          disabled={isDisabled}
          onClick={onRequestCode}
          className="g-recaptcha"
          data-sitekey={captchaType === CaptchaType.reCaptcha ? process.env.REACT_APP_RECAPTCHA_SITE_KEY : undefined}
          data-callback="onRequestCode"
          data-action={RecaptchaActions.resetPassword}
        >
          <FormattedMessage id="resetPassword.oneTimePinStep.nextButton.label" />
        </Button>
      )}
    </>
  );

  return (
    <>
      {
        isValueValid ? (
          <Button
            type="submit"
            style="dark"
            testId="submit-button"
            ariaLabel="resetPassword.oneTimePinStep.nextButton.ariaLabel"
          >
            <FormattedMessage id="resetPassword.nextButton.label" />
          </Button>
        ) : <ButtonNoSubmit />
      }
    </>
  );
};
